// test736
(736 && 0);
